import './index.css';
import React from 'react';
var NoDataSource = function NoDataSource(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, title && "Component Name: ".concat(title), /*#__PURE__*/React.createElement("h3", {
    className: "m-0"
  }, "No DataSource")))));
};
var commonStyles = "cfp7wo8";
export default NoDataSource;